import React, { useEffect, useState } from 'react';
import { ContentEmbeddedAssetBlock } from './types';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { localeMap } from '../inc/utils';

interface Props {
  fieldValue: ContentEmbeddedAssetBlock;
  includes: any;
}

const mapStateToProps = (state: any) => ({
  includes: state.contentful.includes,
});

const EmbeddedAssetBlock = (props: Props) => {
  const { fieldValue, includes } = props;
  const [currentLang, setCurrentLang] = useState<string>(localeMap.get(i18next.language) || '');
  const [imageUrl, setImageUrl] = useState<string>('');

  useEffect(() => {
    i18next.on('languageChanged', function (lng) {
      setCurrentLang(localeMap.get(lng) || '');
    });
  }, []);

  useEffect(() => {
    const id = fieldValue.data.target.sys.id;
    const asset = includes[currentLang]?.[id];
    if (asset?.fields?.file?.url) {
      setImageUrl(asset.fields.file.url);
    } else {
      setImageUrl('');
      // Warn only when language data is loaded but asset is missing (real problem)
      if (includes[currentLang]) {
        console.warn(`Contentful asset not found: ${id} for language: ${currentLang}`);
      }
    }
  }, [includes, fieldValue, currentLang]);

  return (
    <>
      <div style={{ textAlign: 'center' }}>
        {imageUrl && <img style={{ maxWidth: '100%' }} src={imageUrl} alt="" />}
      </div>
    </>
  );
};

export default connect(mapStateToProps)(EmbeddedAssetBlock);
